import { Controller } from "@hotwired/stimulus"
import { badgeClasses } from '@/utils/badge_classes'

export default class extends Controller {
  static targets = ["form", "radio", "taxOrganizerId"]

  handleChange(event) {
    const selectedValue = event.target.value
    const taxOrganizerId = this.taxOrganizerIdTarget.value

    // Prompt user to type "CONFIRM"
    const confirmation = prompt('To change the responsible party, please type "CONFIRM" (all caps):')

    if (confirmation === "CONFIRM") {
      // User confirmed, proceed with the update
      this.updateResponsibleParty(taxOrganizerId, selectedValue)
    } else {
      // User didn't confirm or typed wrong text, revert the radio selection
      // Find and check the radio button that was originally checked
      const originalValue = selectedValue === 'client_advisor' ? 'customer' : 'client_advisor'
      const originalRadio = this.radioTargets.find(radio => radio.value === originalValue)
      if (originalRadio) {
        originalRadio.checked = true
      }
    }
  }

  async updateResponsibleParty(taxOrganizerId, newValue) {
    try {
      const response = await fetch(`/admin/tax-organizers/business/${taxOrganizerId}/update_responsible_party`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          completion_responsible: newValue
        })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        // Update the badge in the modal header without reloading
        this.updateBadge(newValue)
        // Reload the history frame to show the new history entry
        this.reloadHistoryFrame()
      } else {
        // Show error message
        alert(`Error: ${data.message || 'Failed to update responsible party'}`)
        this.revertRadioSelection(newValue)
      }
    } catch (error) {
      console.error('Error updating responsible party:', error)
      alert('An error occurred while updating the responsible party')
      this.revertRadioSelection(newValue)
    }
  }

  updateBadge(newValue) {
    const badge = document.getElementById('completion-responsible-badge')
    if (badge) {
      badge.className = badgeClasses({ variant: newValue === 'client_advisor' ? 'primary' : 'info' })
      badge.textContent = newValue === 'client_advisor' ? 'Client advisor' : 'Customer'
    }
  }

  revertRadioSelection(newValue) {
    const originalValue = newValue === 'client_advisor' ? 'customer' : 'client_advisor'
    const originalRadio = this.radioTargets.find(radio => radio.value === originalValue)
    if (originalRadio) {
      originalRadio.checked = true
    }
  }

  reloadHistoryFrame() {
    const historyFrame = document.querySelector('turbo-frame#history_tab_frame')
    if (historyFrame) {
      historyFrame.reload()
    }
  }
}
